import script from "./CreateOrder.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateOrder.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__